import { apiClient } from './client';
import type { ApiResponse } from './types';

export interface DashboardStats {
  paymentCount: number;
  rewardPoints: number;
  rewardCount: number;
}

export interface UserService {
  getDashboardStats(): Promise<ApiResponse<DashboardStats>>;
}

export const userService: UserService = {
  /**
   * Get current user's dashboard statistics
   */
  async getDashboardStats(): Promise<ApiResponse<DashboardStats>> {
    return apiClient.get<ApiResponse<DashboardStats>>('/users/dashboard/stats');
  },
};
